import { FC, SVGProps } from "react";

export const CheckIcon: FC<SVGProps<SVGSVGElement>> = ({
  fill = "white",
  className,
  width = 12,
  height = 12,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M2 6.2L4.6 8.8L10 3"
        stroke={fill}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
